import React from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import {
  BookmarkBorderRounded,
  MoreHorizRounded,
  IosShareRounded,
  BookmarkRounded,
} from '@mui/icons-material';
import { IMenuLink } from '@/infrastructure/interfaces/i-link';
import { useTranslation } from 'next-i18next';
import { ReadSurah } from '@/infrastructure/class/read-surah';
import { NavigatorEvents } from '@/utils/helpers/navigator-events';
import { routes } from '@/infrastructure/const/routes';
import { useAuth } from '@/infrastructure/context/auth-context';
import { useReadBookmarks } from '@/infrastructure/context/read-bookmarks-context';

interface IReadSurahsListItemMenuBtnProps {
  data: ReadSurah;
  className?: string;
}

const ReadSurahsListItemMenuBtn: React.FC<IReadSurahsListItemMenuBtnProps> = (
  props
) => {
  const { data, className = '' } = props;
  const { readBookmarks, changeReadBookmark, isBookmarked } =
    useReadBookmarks();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const { checkAuth, authUser, showMessage } = useAuth();

  const bookmark = isBookmarked(data);

  const { t: tButtons } = useTranslation('buttons');

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const onShare = async () => {
    await NavigatorEvents.copyString(
      `${window.location.origin}${routes.surahRead}/${data.slug}`
    );
    handleClose();
    showMessage(tButtons('linkCopied'));
  };
  const onBookmark = async () => {
    handleClose();
    await checkAuth();
    if (authUser) {
      await changeReadBookmark({ user: authUser, readSurah: data });
      const message = bookmark
        ? tButtons('removedFromBookmarks')
        : tButtons('addedToBookmarks');
      showMessage(message);
    }
  };

  const menuItems: IMenuLink[] = [
    {
      title: tButtons('addToBookmark'),
      icon: BookmarkBorderRounded,
      action: onBookmark,
      visible: !bookmark,
    },
    {
      title: tButtons('removeFromBookmark'),
      icon: BookmarkRounded,
      action: onBookmark,
      visible: !!bookmark,
    },
    {
      title: tButtons('share'),
      icon: IosShareRounded,
      action: onShare,
      visible: true,
    },
  ];

  return (
    <div className={className}>
      <IconButton
        aria-label="surah menu options"
        color="error"
        onClick={handleClick}
        size="small"
      >
        <MoreHorizRounded />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {menuItems.map(
          (menuItem) =>
            menuItem.visible && (
              <MenuItem key={menuItem.title} onClick={menuItem.action}>
                {menuItem.icon && (
                  <i>
                    <menuItem.icon />
                  </i>
                )}
                <span> {menuItem.title}</span>
              </MenuItem>
            )
        )}
      </Menu>
    </div>
  );
};

export default ReadSurahsListItemMenuBtn;
